import React from 'react';
import { personalInfo } from '../data/portfolioData';

export const Privacy = () => (
  <div className="shell">
    <article className="legal">
    <p className="meta">Privacy policy</p>
    <h1>What this site knows about you</h1>
    <p className="lede legal-updated">
      Short version: this is a personal portfolio. It sets no cookies, runs no
      analytics, and keeps no database of visitors.
    </p>

    <h2>Who runs this site</h2>
    <p>
      This site is operated by {personalInfo.name}, an individual, from Boston,
      Massachusetts. For anything in this policy, write to{' '}
      <a className="link" href={`mailto:${personalInfo.email}`}>
        {personalInfo.email}
      </a>
      .
    </p>

    <h2>What is collected when you simply read the page</h2>
    <p>
      Nothing is collected by me directly. There are no cookies, no analytics
      scripts, no advertising pixels, and no third-party trackers. Three
      service providers do see technical data because they deliver parts of
      the page to you:
    </p>
    <ul>
      <li>
        Netlify, the host, records standard server log data such as your IP
        address, browser user agent, the page requested, and the time of the
        request. This is ordinary web-server logging and is handled under
        Netlify's own privacy policy.
      </li>
      <li>
        Google Fonts serves the typefaces used here. Requesting a font file
        exposes your IP address and user agent to Google under its own privacy
        policy.
      </li>
      <li>
        GitHub answers the requests your browser makes to its public API for
        the live repository details in the projects section, such as the date
        of the last push. GitHub sees your IP address and user agent under its
        own privacy policy. The answers are kept in your browser's session
        storage until you close the tab, so a reload does not ask again. They
        contain repository facts only, nothing about you.
      </li>
    </ul>

    <h2>The live demo</h2>
    <p>
      The collaborative-editing demo in the projects section runs entirely in
      your browser. What you type into it is never sent anywhere and is gone
      when you leave the page.
    </p>

    <h2>The assistant</h2>
    <p>
      This site includes an assistant that answers questions about my
      background. When you send it a message, the text of your conversation is
      forwarded from your browser to a serverless function on Netlify, which
      passes it to the Anthropic API to generate a reply. Please note:
    </p>
    <ul>
      <li>
        Your messages are not written to any database, log, or file that I
        control. The conversation lives only in your browser tab and disappears
        when you close or refresh it.
      </li>
      <li>
        The content of your messages is processed by Anthropic under its own
        privacy and data-handling terms as an API customer of mine.
      </li>
      <li>
        Do not type anything sensitive, confidential, or personally identifying
        into the assistant. It is a demonstration, not a secure channel.
      </li>
    </ul>

    <h2>Email and other contact</h2>
    <p>
      If you email me, call me, or connect on LinkedIn or GitHub, I will have
      whatever you chose to send, held in the relevant inbox or account for as
      long as it is useful. I do not add anyone to a mailing list and I do not
      sell, rent, or share contact details with anyone.
    </p>

    <h2>Links off this site</h2>
    <p>
      Project links point to GitHub, and the social links point to LinkedIn and
      GitHub. Once you follow one, that service's privacy policy applies, not
      this one.
    </p>

    <h2>Your rights</h2>
    <p>
      Because no personal data is stored by me, there is usually nothing to
      access, correct, or delete. If you have emailed me and want that
      correspondence deleted, ask and I will delete it.
    </p>

    <h2>Children</h2>
    <p>
      This site is aimed at recruiters, engineers, and collaborators. It is not
      directed at children under 13 and I do not knowingly collect their data.
    </p>

    <h2>Changes</h2>
    <p>
      If the site starts doing something new, such as adding analytics or a
      contact form, this page will be updated before that happens.
    </p>
    <p className="meta legal-updated">Last updated 17 October 2026</p>
    </article>
  </div>
);

export default Privacy;
